<script>
    export default {
        name: 'TableFooter',
        props: {
            items: {
                type: Array,
                default: () => []
            }
        },
        computed: {
            validItems() {
                return this.items.filter(item => !!item)
            }
        }
    }
</script>

<template>
    <VFooter
        class="table-footer mt-2 mb-10 float-right vc-disable-selection"
        color="transparent">
        <div v-for="item in validItems" :key="item.label"
            class="table-footer__item text-no-wrap">
            <VIcon v-if="item && item.icon"
                small
                class="mdi"
                :class="item.icon ? `mdi-${item.icon}` : ''"/>
            <span v-if="item && item.label"
                class="overline font-italic"
                :class="item.class"
                v-text="item.label"></span>
        </div>
    </VFooter>
</template>

<style>
    .table-footer {
        gap: 12px;
    }

    .table-footer__item {
        display: flex;
        flex-flow: row nowrap;
        gap: 4px;
    }

    .v-footer .overline {
        font-size: 10px !important;
    }
</style>
